import {StyleProp, View, ViewStyle} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import React from 'react';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';

const Tag = ({
  label,
  style,
  backgroundColor,
}: {
  label?: string;
  style?: StyleProp<ViewStyle>;
  backgroundColor?: string;
}) => {
  const {calcActualSize} = useScreenSize();

  if (typeof document !== 'undefined') {
    return (
      <div
        style={{
          backgroundColor,
          ...stylesWeb.wrap,
        }}>
        <span style={stylesWeb.text}>{label}</span>
      </div>
    );
  }
  return (
    <View
      style={[
        {
          backgroundColor,
          padding: calcActualSize(theme.paddingSize.xxs),
          borderRadius: calcActualSize(theme.paddingSize.xs),
        },
        style,
      ]}>
      <Text color={theme.basicColor.white} fontFamily="fontInterBold">
        {label}
      </Text>
    </View>
  );
};

export default Tag;

const stylesWeb: Record<string, React.CSSProperties> = {
  wrap: {
    padding: '0.125rem',
    borderRadius: '0.25rem',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: theme.basicColor.white,
    fontFamily: 'Inter-Bold',
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },
};
